import React from 'react';
import {
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { EvalOption } from '../common/page-data';
import Grid from '@mui/material/Grid';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { More } from './more';
interface ComponentProps {
  tagText: string;
  reasonText: string;
  evalOption: EvalOption;
  positive?: boolean;
  disabled?: boolean;
  onChange: (answer: EvalOption) => void;
}

type Props = ComponentProps;

const TagListComp: React.FC<Props> = (props) => {
  const { disabled, tagText, reasonText, evalOption, positive, onChange } = props;

  return (
    <Grid
      item
      container
      xs={11}
      alignItems='left'
      justifyContent='end'
      spacing={3}
      direction='column'
    >
      <Grid
        item
        container
        xs={'auto'}
        alignItems='center'
        justifyContent='space-between'
        spacing={1}
        direction='row'
        width={'100%'}
      >
        {/* <Grid container></Grid> */}
        {/* <Stack direction={'row'}> */}
        <Grid item xs={10}>
          <ReactMarkdown>{tagText}</ReactMarkdown>
        </Grid>
        <Grid item xs={2}>
          <More reason={reasonText} />
        </Grid>
        {/* </Stack> */}
        {/* <Grid item height={'max-content'}> */}
        {/* <ReactMarkdown>{tagText}</ReactMarkdown> */}

        {/* </Grid>
        <Grid item sx={{ padding: '0 0 0 1em' }}> */}
        {/* {reasonText} */}
        {/* </Grid> */}
      </Grid>
      <Grid item xs={'auto'}>
        <ToggleButtonGroup
          disabled={disabled ?? false}
          sx={{ color: 'black', textTransform: 'none' }}
          fullWidth
          size='small'
          value={evalOption}
          exclusive={true}
          onChange={(
            _event: React.MouseEvent<HTMLElement, MouseEvent>,
            value: EvalOption
          ) => onChange(value)}
        >
          <ToggleButton
            sx={{ color: 'black', textTransform: 'none' }}
            value={EvalOption.Correct}
            key='full'
          >
            {positive ? 'Demonstrated' : 'Avoided'}
          </ToggleButton>
          <ToggleButton
            sx={{ color: 'black', textTransform: 'none' }}
            value={EvalOption.PartiallyCorrect}
            key='partial'
          >
            {positive ? 'Partially Demonstrated' : 'Partially Avoided'}
          </ToggleButton>
          <ToggleButton
            sx={{ color: 'black', textTransform: 'none' }}
            value={EvalOption.Incorrect}
            key='not'
          >
            {positive ? 'Not Demonstrated' : 'Not Avoided'}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
};

//******************************************************************************
export const TagListAnswer = TagListComp;
